import React from "react";
import ButtonSecondary from "../buttons/ButtonSecondary";

const ModalDeleteFile = ({ isOpen, onClose, item, onDelete, messageWarning }) => {
  const handleDelete = () => {
    if (onDelete) {
      // Pentru cazul de multiple items, nu pasăm item.id
      if (item.type === 'multiple') {
        onDelete();
      } else {
        onDelete(item.id);
      }
    }
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  if (!isOpen || !item) {
    return null;
  }

  const isFolder = item.type === "folder";
  const isMultiple = item.type === "multiple";
  const itemType = isMultiple ? "items" : (isFolder ? "folder" : "file");

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-lg mx-6 max-w-[500px]">
        <h2 className="text-h6 text-dark4 mb-4 text-center">
          Are you sure you want to delete {isMultiple ? "these" : "this"} {itemType}?
        </h2>

        {messageWarning && (
          <div className="bg-yellow-50 border border-yellow-200 rounded p-3 mb-4">
            <p className="text-bodyMR text-dark4 text-center">
              {messageWarning}
            </p>
          </div>
        )}

        <p className="text-bodyMR text-dark4 text-center mb-2">
          This action is irreversible.
        </p>

        {(isFolder || isMultiple) && (
          <p className="text-bodySR text-gray-600 text-center mb-4">
            {isMultiple
              ? "Some of these items might contain files that are attached in messages. If deleted, they will be removed from the messages as well."
              : "This folder contains files that are attached in messages. If deleted, they will be removed from the messages as well."
            }
          </p>
        )}

        <div className="flex justify-center mt-6 space-x-4">
          <ButtonSecondary
            text="Delete"
            customClass="bg-redDark text-white text-bodyMR px-[22px] py-[10px]"
            onClick={handleDelete}
          />
          <ButtonSecondary
            text="Cancel"
            customClass="bg-white text-dark4 text-bodyMR border border-dark4 px-[22px] py-[10px]"
            onClick={handleCancel}
          />
        </div>
      </div>
    </div>
  );
};

export default ModalDeleteFile;
